/* ==========================================================================
   Jauge « 10 épices » : pose et retire le code « 10% AVEC UN COFFRET » (2026-10-02, renommé le 2026-10-06)

   Le Liquid (snippets/jauge-epices.liquid) dit l'état du panier dans les
   data-* ; ce fichier ne fait qu'aligner le code sur cet état :
   - coffret au panier, 1 à 9 épices, code absent  -> on l'ajoute ;
   - plus de coffret, code présent                 -> on le retire.
   À partir de 10 épices, la remise automatique fait le même travail : on ne
   touche à rien, sinon Shopify garderait l'une des deux et le code paraîtrait
   « non appliqué » à chaque rendu.

   L'élément est re-rendu à chaque changement du panier (le tiroir remplace son
   HTML), donc connectedCallback suffit : pas d'écoute d'événement à maintenir.

   Garde-fou : on ne retente jamais deux fois de suite la MÊME demande. Sans
   lui, un code refusé par Shopify relancerait la mise à jour à chaque rendu,
   et sur la page panier, qui se recharge, en boucle. On ne mémorise que la
   dernière demande : retirer puis remettre un coffret reste possible.
   ========================================================================== */
(function () {
  if (customElements.get('jauge-epices')) return;

  var CLE = 'jauge-epices:derniere';
  function dejaTente(cle) {
    var derniere = null;
    try { derniere = sessionStorage.getItem(CLE); } catch (e) { derniere = window.__jaugeEpices || null; }
    if (derniere === cle) return true;
    try { sessionStorage.setItem(CLE, cle); } catch (e) { window.__jaugeEpices = cle; }
    return false;
  }

  class JaugeEpices extends HTMLElement {
    connectedCallback() {
      var self = this;
      setTimeout(function () { self.synchroniser(); }, 0);
    }

    synchroniser() {
      var coffret = this.dataset.coffret === 'true';
      var applique = this.dataset.applique === 'true';
      var nb = parseInt(this.dataset.nb, 10) || 0;
      var code = this.dataset.code;
      if (!code || !window.routes || !window.routes.cart_update_url) return;

      var ajouter = coffret && nb > 0 && nb < 10 && !applique;
      var retirer = !coffret && applique;
      if (!ajouter && !retirer) return;

      var codes = (this.dataset.codes || '').split('|').filter(function (c) {
        return c && c.toUpperCase() !== code.toUpperCase();
      });
      if (ajouter) codes.push(code);

      var cle = (ajouter ? '+' : '-') + nb + ':' + codes.join(',');
      if (dejaTente(cle)) return;

      var tiroir = this.closest('cart-drawer') || document.querySelector('cart-drawer');
      var sections = tiroir && tiroir.getSectionsToRender
        ? tiroir.getSectionsToRender().map(function (s) { return s.id; })
        : [];

      fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections: sections })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          /* Page panier : ses totaux viennent d'une autre section, le plus sûr
             est de la recharger. Le garde-fou empêche toute boucle. */
          if (document.getElementById('main-cart-items')) {
            window.location.reload();
            return;
          }
          if (!tiroir || !data || !data.sections) return;

          /* Tiroir ouvert : rendu normal. Fermé (chargement d'une page avec un
             coffret déjà au panier) : mise à jour silencieuse, sans l'ouvrir,
             renderContents l'ouvrirait. */
          if (tiroir.classList.contains('active')) {
            tiroir.renderContents(data);
            return;
          }
          tiroir.getSectionsToRender().forEach(function (s) {
            var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
            if (el && data.sections[s.id]) {
              el.innerHTML = tiroir.getSectionInnerHTML(data.sections[s.id], s.selector);
            }
          });
          var voile = tiroir.querySelector('#CartDrawer-Overlay');
          if (voile) voile.addEventListener('click', tiroir.close.bind(tiroir));
        })
        .catch(function () {});
    }
  }

  customElements.define('jauge-epices', JaugeEpices);
})();
